import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs';

import {
    PAYCHEX_ERROR_STEP,
    paychexStepsSetStep,
} from '@perpay-web/fintech/components/composite/PayrollPaymentSetup/usePaychexStepsContext';
import { createPayrollDeductionError } from '@perpay-web/fintech/hooks/dataModule/useCreatePayrollDeductionContext';

export const payrollSetupPaychexError = (action$) =>
    action$.pipe(
        ofType(createPayrollDeductionError().type),
        mergeMap(() => [paychexStepsSetStep(PAYCHEX_ERROR_STEP)]),
    );
